// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap */
import { Record } from "immutable"

import { PLACE_VALUE_MODES, PLACE_TYPES } from "../consts/place"
import type { PlaceValueMode } from "../consts/place"
import Place from "./Place"
import Radius from "./Radius"

type Value = string | Place | Radius
export type Geo = {
  lat: number
  lng: number
}

export type Input =
  | string
  | {
      mode?: PlaceValueMode
      value?: Value
      isDefault?: boolean
    }

export type Plain = {
  mode?: PlaceValueMode
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any | string
  isDefault?: boolean
}

const SearchPlaceRecord = Record({
  mode: PLACE_VALUE_MODES.TEXT,
  value: "",
  isDefault: false,
})

class SearchPlace extends SearchPlaceRecord {
  constructor(raw: Input = {}) {
    let input = raw // TODO: Check
    if (typeof input === "string") {
      const value = input
      input = {
        value,
      }
    }

    super(input)
  }

  getType() {
    // @ts-expect-error: Flow to TS migration.
    switch (this.mode) {
      case PLACE_VALUE_MODES.ANYWHERE:
        return PLACE_VALUE_MODES.ANYWHERE
      case PLACE_VALUE_MODES.RADIUS:
        return PLACE_VALUE_MODES.RADIUS
      case PLACE_VALUE_MODES.PLACE:
        // @ts-expect-error: Flow to TS migration.
        return this.value.getType()
      default:
        return "place"
    }
  }

  getId(): string | null | undefined {
    // @ts-expect-error: Flow to TS migration.
    switch (this.mode) {
      case PLACE_VALUE_MODES.PLACE:
        // @ts-expect-error: Flow to TS migration.
        return this.value.id

      case PLACE_VALUE_MODES.RADIUS:
        // @ts-expect-error: Flow to TS migration.
        return this.value.getId()

      case PLACE_VALUE_MODES.ID:
      case PLACE_VALUE_MODES.TEXT:
        // @ts-expect-error: Flow to TS migration.
        return this.value

      case PLACE_VALUE_MODES.ANYWHERE:
        // @ts-expect-error: Flow to TS migration.
        return this.mode

      case PLACE_VALUE_MODES.UNSELECTED:
        return "-"

      default:
        return ""
    }
  }

  getSearchId(): string | null | undefined {
    // @ts-expect-error: Flow to TS migration.
    switch (this.mode) {
      case PLACE_VALUE_MODES.PLACE:
        // @ts-expect-error: Flow to TS migration.
        return this.value.id

      case PLACE_VALUE_MODES.RADIUS:
        // @ts-expect-error: Flow to TS migration.
        return this.value.getSearchId()

      case PLACE_VALUE_MODES.ID:
      case PLACE_VALUE_MODES.TEXT:
        // @ts-expect-error: Flow to TS migration.
        return this.value

      case PLACE_VALUE_MODES.ANYWHERE:
        // @ts-expect-error: Flow to TS migration.
        return this.mode

      case PLACE_VALUE_MODES.UNSELECTED:
        return "-"

      default:
        return null
    }
  }

  // is a city or an airport (or station ... which is basically an airport ... just without runway and planes and useless security checks)
  isCityOrAirport(): boolean {
    // @ts-expect-error: Flow to TS migration.
    const { mode, value } = this
    return (
      mode === PLACE_VALUE_MODES.PLACE &&
      (value.type === PLACE_TYPES.TRAIN_STATION ||
        value.type === PLACE_TYPES.AIRPORT ||
        value.type === PLACE_TYPES.BUS_STATION ||
        value.type === PLACE_TYPES.CITY ||
        value.type === PLACE_TYPES.SPECIAL)
    )
  }

  // is larger than one city
  isLarge(): boolean {
    // @ts-expect-error: Flow to TS migration.
    const { mode } = this
    return (
      mode === PLACE_VALUE_MODES.RADIUS ||
      mode === PLACE_VALUE_MODES.ANYWHERE ||
      (mode === PLACE_VALUE_MODES.PLACE && !this.isCityOrAirport())
    )
  }

  isAnywhere(): boolean {
    // @ts-expect-error: Flow to TS migration.
    return this.mode === PLACE_VALUE_MODES.ANYWHERE || this.value.id === "anywhere"
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering
  static fromPlainJS(plain: Plain): SearchPlace {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const input: Record<string, any> = {}
    if (plain.mode === PLACE_VALUE_MODES.RADIUS) {
      input.value = Radius.fromPlainJS(plain.value)
    }

    if (plain.mode === PLACE_VALUE_MODES.PLACE) {
      input.value = Place.fromPlainJS(plain.value)
    }

    return new SearchPlace({ ...plain, ...input })
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering
  static anywhere(): SearchPlace {
    return new SearchPlace({ mode: PLACE_VALUE_MODES.ANYWHERE })
  }

  getGeo(): Geo | null | undefined {
    // @ts-expect-error: Flow to TS migration.
    const { mode, value } = this
    if (
      (mode === PLACE_VALUE_MODES.PLACE && value.checkLatLng()) ||
      mode === PLACE_VALUE_MODES.RADIUS
    ) {
      return {
        lat: value.lat,
        lng: value.lng,
      }
    }
    return null
  }

  hasParent(parent: SearchPlace): boolean {
    if (parent.getId() === "anywhere") return true
    // @ts-expect-error: Flow to TS migration.
    if (this.mode !== PLACE_VALUE_MODES.PLACE) return false

    // @ts-expect-error: Flow to TS migration.
    return parent.mode === PLACE_VALUE_MODES.RADIUS
      ? // @ts-expect-error: Flow to TS migration.
        parent.value.isPlaceInRadius(this.value)
      : // @ts-expect-error: Flow to TS migration.
        this.value.isIncludedDeepIn([parent.getSearchId()])
  }

  equals(place: SearchPlace): boolean {
    return this.getSearchId() === place.getSearchId()
  }
}

export default SearchPlace
